import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { CaseCategoryDescriptor } from './model/case.category';
import { IDataService } from '../common/IDataService';

@Injectable()
export class CaseCategoryService extends RESTServiceBase implements IDataService<CaseCategoryDescriptor> {

  constructor(
    authService: AuthService,
    config: AppConfig,
  ) {
    super(
      'v1',
      'CaseCategoryManagement',
      authService,
      config.CAMSConfig
    );

  }

  public create(caseCategory: CaseCategoryDescriptor): Promise<CaseCategoryDescriptor> {
    return super.post<CaseCategoryDescriptor>(
      new CaseCategoryDescriptor({
        id: undefined,
        href: undefined,
        name: caseCategory.name,
        isOrganizationRequired: caseCategory.isOrganizationRequired,
        isFormRequired: caseCategory.isFormRequired,
        isDataPeriodRequired: caseCategory.isDataPeriodRequired,
        allowAttachments: caseCategory.allowAttachments,
        allowedCreatorType: caseCategory.allowedCreatorType,
        
        modified: caseCategory.modified,
        deleted: caseCategory.deleted
      }));
  }

  public getCaseCategories(view?: View): Promise<List<CaseCategoryDescriptor>> {
    return super.get<List<CaseCategoryDescriptor>>(undefined, view);
  }


  async GetList(v: View): Promise<List<CaseCategoryDescriptor>> {
    return await this.getCaseCategories(v);
  }
  async GetById(id: string): Promise<CaseCategoryDescriptor> {
    return await this.getById(id);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: CaseCategoryDescriptor): Promise<CaseCategoryDescriptor> {
    return super.put<CaseCategoryDescriptor>(id, role);
  }

  public getById(id: string): Promise<CaseCategoryDescriptor> {
    return super.get<CaseCategoryDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case.category/case.category.service.ts